export const Root              = "/index.html"              ;
/*export const Home              = Root + "home"              ;
export const Weigh             = Root + "pesate"            ;
export const Libras            = Root + "bilance"           ;
export const Plants            = Root + "impianti"          ;         
export const Companies         = Root + "aziende"           ; 
export const Fields            = Root + "campi"             ; 
export const Tables            = Root + "tabelle"           ; 
export const Operators         = Root + "operatori"         ; 
export const Settings          = Root + "impostazioni"      ; 
export const Printers          = Root + "stampanti"         ; 
export const Prints            = Root + "stampe"            ; 
export const EmailConfirmation = Root + "emailConfirmation" ; 
export const Holding           = Root + "holding"           ;  
export const RecoverPassword   = Root + "recuperaPassword"  ; 
export const SignIn            = Root + "registrazione"     ; 
export const ChooseVersion     = Root + "sceltaVersione"    ;
export const Upgrade           = Root + "upgrade"           ;
export const Other             = Root + "*"                 ;*/

export const Home              = "/" + "home"              ;
export const Weigh             = "/" + "pesate"            ;
export const Libras            = "/" + "bilance"           ;
export const Plants            = "/" + "impianti"          ;         
export const Companies         = "/" + "aziende"           ; 
export const Fields            = "/" + "campi"             ; 
export const Tables            = "/" + "tabelle"           ; 
export const Operators         = "/" + "operatori"         ; 
export const Settings          = "/" + "impostazioni"      ; 
export const Printers          = "/" + "stampanti"         ; 
export const Prints            = "/" + "stampe"            ; 
export const EmailConfirmation = "/" + "emailConfirmation" ; 
export const Holding           = "/" + "holding"           ;  
export const RecoverPassword   = "/" + "recuperaPassword"  ; 
export const SignIn            = "/" + "registrazione"     ; 
export const ChooseVersion     = "/" + "sceltaVersione"    ;
export const Upgrade           = "/" + "upgrade"           ;
export const Other             = "/" + "*"                 ;


// WEBPACK FOOTER //
// ./src/Utils/Strings/Route.js